var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQontactBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 700 1050",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.58 992.159C516.736 980 516.736 960.289 504.58 948.13L174.399 617.877C162.243 605.719 142.536 605.719 130.38 617.877C118.225 630.036 118.225 649.747 130.38 661.906L460.561 992.159C472.717 1004.32 492.424 1004.32 504.58 992.159Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.212 823.703C195.58 817.334 195.58 807.018 189.212 800.649L16.3996 627.799C10.0323 621.43 -0.281821 621.43 -6.64916 627.799C-13.0165 634.168 -13.0165 644.484 -6.64916 650.853L166.164 823.703C172.531 830.072 182.845 830.072 189.212 823.703Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M673.025 916.181C679.339 909.865 679.339 899.654 673.025 893.338L501.817 722.093C495.502 715.777 485.293 715.777 478.979 722.093C472.664 728.409 472.664 738.62 478.979 744.936L650.186 916.181C656.501 922.497 666.71 922.497 673.025 916.181Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M687.417 697.565C693.574 691.407 693.574 681.459 687.417 675.301L520.524 508.372C514.368 502.214 504.422 502.214 498.265 508.372C492.108 514.53 492.108 524.478 498.265 530.636L665.158 697.565C671.315 703.724 681.26 703.724 687.417 697.565Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M506.501 454.343C517.578 443.237 517.578 425.263 506.501 414.183L205.289 112.906C194.212 101.8 176.215 101.8 165.138 112.906C154.061 124.012 154.061 141.986 165.138 153.066L466.35 454.343C477.427 465.449 495.424 465.449 506.501 454.343Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M373.023 1283.8C390.757 1266.07 390.757 1237.33 373.023 1219.59L-108.5 737.962C-126.234 720.224 -154.966 720.224 -172.7 737.962C-190.433 755.7 -190.433 784.438 -172.7 802.176L308.797 1283.8C326.531 1301.54 355.263 1301.54 372.997 1283.8L373.023 1283.8Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.521 89.1414C241.098 80.562 241.098 66.6667 232.521 58.0873L-0.360447 -174.845C-8.93795 -183.424 -22.8304 -183.424 -31.4079 -174.845C-39.9853 -166.266 -39.9853 -152.37 -31.4079 -143.791L201.474 89.1414C210.051 97.7208 223.943 97.7208 232.521 89.1414Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M690.548 46.8762C697.179 40.2443 697.179 29.5069 690.548 22.9013L510.71 -156.976C504.08 -163.608 493.345 -163.608 486.741 -156.976C480.11 -150.344 480.11 -139.606 486.741 -133.001L666.579 46.8762C673.209 53.5081 683.944 53.5081 690.548 46.8762Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.041 362.076C276.724 351.391 276.724 334.074 266.041 323.39L-23.9882 33.2966C-34.6706 22.6118 -51.9834 22.6118 -62.6658 33.2966C-73.3482 43.9813 -73.3482 61.2979 -62.6658 71.9827L227.364 362.076C238.046 372.76 255.359 372.76 266.041 362.076Z",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M724.2 521.004C733.383 511.82 733.383 496.924 724.2 487.74L474.795 238.28C465.613 229.096 450.721 229.096 441.538 238.28C432.355 247.465 432.355 262.36 441.538 271.545L690.943 521.004C700.126 530.189 715.018 530.189 724.2 521.004Z",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M177.109 534.584C182.082 529.61 182.082 521.531 177.109 516.53L41.8165 381.208C36.8437 376.234 28.766 376.234 23.7669 381.208C18.7941 386.182 18.7941 394.261 23.7669 399.262L159.06 534.584C164.033 539.558 172.11 539.558 177.109 534.584Z",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M540.653 1220.2C552.572 1208.27 552.572 1188.93 540.653 1177.01L216.919 853.205C205 841.283 185.661 841.283 173.742 853.205C161.823 865.126 161.823 884.469 173.742 896.391L497.476 1220.2C509.395 1232.12 528.734 1232.12 540.653 1220.2Z",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M358.868 82.5884C369.314 72.1405 369.314 55.1923 358.868 44.7445L75.0215 -239.164C64.5759 -249.612 47.6314 -249.612 37.1858 -239.164C26.7402 -228.716 26.7402 -211.768 37.1858 -201.32L321.032 82.5884C331.478 93.0363 348.422 93.0363 358.868 82.5884Z",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M871.728 450.185C890.751 431.158 890.751 400.288 871.728 381.261L354.974 -135.606C335.951 -154.633 305.088 -154.633 286.065 -135.606C267.042 -116.579 267.042 -85.709 286.065 -66.6818L802.819 450.185C821.842 469.213 852.705 469.213 871.728 450.185Z",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M821.079 1257.7C835.366 1243.41 835.366 1220.25 821.079 1205.98L433.25 818.071C418.963 803.781 395.809 803.781 381.548 818.071C367.261 832.362 367.261 855.521 381.548 869.784L769.377 1257.7C783.664 1271.99 806.818 1271.99 821.079 1257.7Z",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M569.043 783.885C583.856 769.069 583.856 745.041 569.043 730.225L166.717 327.811C151.903 312.994 127.881 312.994 113.068 327.811C98.2545 342.627 98.2545 366.655 113.068 381.471L515.394 783.885C530.207 798.702 554.23 798.702 569.043 783.885Z",
    fill: "#717171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQontactBackground);
export default __webpack_public_path__ + "static/media/QontactBackground.d0af970afd4f54c7c2e56bc591aaef64.svg";
export { ForwardRef as ReactComponent };